<template>
  <div class="VRShow">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toPath('/achievements')">成果展示</span>
          <span>>></span>
          <span>VR</span>
        </div>
      </div>
      <div class="title">VR展示馆</div>
      <div class="search-box">
        <input type="text" v-model="fruitName" placeholder="请输入相关字段，点击搜索">
        <span class="search-btn" @click="pageChange(1)">搜索</span>
      </div>
      <div class="VR">
        <ul>
          <li v-for="fruit in fruitList" :key="fruit.id">
            <div class="image-box">
              <img v-if="fruit.coverImage" :src="fileUrl + fruit.coverImage" alt="">
              <img v-else :src="'/static/images/fruit/'+fruit.fruitStyle.replace('/', '-') + '.png'" alt="">
              <span class="label-text">{{fruit.nowStage}}</span>
            </div>
            <div class="content">
              <p class="name-box">
                <span class="name" @click="goDetail(fruit.id)">{{fruit.fruitName}}</span>
                <img v-if="fruit.vrUrl" src="../../assets/images/360@2x.png" alt="VR">
                <img v-if="fruit.mp4Url" src="../../assets/images/video@2x.png" alt="视频">
              </p>
              <p class="text"><span>项目名称：</span>{{fruit.projectName}}</p>
              <p class="text"><span>课题名称：</span>{{fruit.taskName}}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :total="page.total"
          :page-size="page.pageSize"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fileUrl: '',
      fruitName: '',
      page: {
        pageNo: 1,
        pageSize: 12,
        total: 0
      },
      fruitList: []
    }
  },
  created () {
    this.pageChange(1);
    this.fileUrl = FileUrl;
  },
  methods: {
    pageChange (current) {
      this.page.pageNo = current;
      this.fetchList();
    },
    fetchList () {
      const _self = this;
      let param = { pageNo: _self.page.pageNo, pageSize: _self.page.pageSize };
      if (_self.fruitName) param.fruitName = _self.fruitName;
      _self.fetch('/dataapi/open/nqi/fruit/listVrShow', param).then(res => {
        _self.fruitList = res.result.records;
        _self.page.total = res.result.total;
        document.body.scrollTop = document.documentElement.scrollTop = 0
      });
    },
    toPath (path) {
      this.$router.push(path)
    },
    goDetail (id) {
      this.$router.push({path: '/fruitDetail', query: {id: id}});
    }
  }
}
</script>

<style lang="less">
.VRShow {
  .pagination-box {
    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }
    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: rgba(46, 92, 154, 1)!important;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.VRShow {
  padding-bottom: 60px;
  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;
    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;
      span {
        margin-right: 7px;
      }
    }
  }
  .title {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }
  .search-box {
    display: flex;
    margin-bottom: 32px;
    padding-left: 60px;
    input {
      margin-right: 24px;
      width: 980px;
      height: 52px;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 26px;
      box-sizing: border-box;
    }
    .search-btn {
      width: 120px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
      cursor: pointer;
    }
  }

  .VR {
    padding-bottom: 1px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        flex: 0 0 410px;
        margin-right: 25px;
        margin-bottom: 20px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .image-box {
          position: relative;
          width: 410px;
          height: 280px;
          img {
            width: 100%;
            height: 100%;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .label-text {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 72px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            background-color: rgba(170, 47, 51, 1);
          }
        }
        .content {
          padding: 24px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-top: 0;
          box-sizing: border-box;
          .name-box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .name {
              cursor: pointer;
              margin-right: 10px;
              font-size: 16px;
              line-height: 22px;
              color: rgba(46, 92, 154, 1);
            }
            img {
              display: block;
              width: 32px;
              height: 32px;
              margin-right: 10px;
            }
          }
          .text {
            margin-bottom: 7px;
            font-size: 14px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.65);
            display: flex;
            span:first-child {
              width: 86px;
            }
          }
          .tip {
            display: flex;
            align-items: center;
            .text {
              margin-right: 12px;
              margin-bottom: 0;
              font-size: 14px;
              line-height: 20px;
              color: rgba(0, 0, 0, 0.65);
            }
            .status {
              width: 48px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              border-radius: 2px;
              &.show {
                background-color: rgba(170, 47, 51, 1);
              }
              &.end {
                background-color: rgba(0, 0, 0, 0.65);
              }
            }
          }
        }
      }
    }
  }

  .pagination-box {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/VRShow/index.vue